import {assert} from 'Asserts';
import {MinimalStorableSummaryWithSchemaId} from 'constants/SampleConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import {StructuredTableColumnSummary} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import APIUtil from 'util/APIUtil';

export default function getMatchingColumnConstraints(
  items: Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId>
): StructuredTableColumnSummary {
  assert(items.length > 0, 'Must have at least 1 item');
  const areStorables = (
    items: Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId>
  ): items is Array<MinimalStorableSummaryWithSchemaId> => APIUtil.isStorable(items[0].id);

  if (areStorables(items)) {
    const areAllSchemasSame = items.every(
      ({storableSchema}) => items[0].storableSchema.id === storableSchema.id
    );
    return {
      validDestinationColumnRequirements: [
        {
          columnType: TableColumnType.TAG_VALUE,
          schemaFieldType: FieldType.STORABLE_LINK,
          folderItemType: null,
        },
      ],
      schemaIdConstraint: areAllSchemasSame ? items[0].storableSchema.id : null,
    };
  }

  const areSameSchema = items.every(({tagSchema}) => tagSchema?.id === items[0].tagSchema?.id);
  const areSameItemType =
    areSameSchema ||
    items.every(({tagSchema}) => tagSchema?.folderItemType === items[0].tagSchema?.folderItemType);
  return {
    validDestinationColumnRequirements: [
      {
        columnType: TableColumnType.TAG_VALUE,
        schemaFieldType: FieldType.BIOENTITY_LINK,
        folderItemType: areSameItemType ? (items[0].tagSchema?.folderItemType ?? null) : null,
      },
    ],
    schemaIdConstraint: areSameSchema ? (items[0].tagSchema?.id ?? null) : null,
  };
}
